import { render } from "./VectorLayer.vue?vue&type=template&id=00d151a2"
import script from "./VectorLayer.vue?vue&type=script&lang=js"
export * from "./VectorLayer.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__